module.exports = __webpack_public_path__ + "img/home5.82a51ae6.jpg";